"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTicketRoute = void 0;
exports.getTicketRoute = '/ticket/';
//# sourceMappingURL=get.route.js.map